export default __webpack_public_path__ + "static/media/school-four.dcc907c4.png";